module.exports = __webpack_public_path__ + "static/media/oreo.5dddd389.png";